import Header from "../../components/Header";
import SelectionsHeader from "../../components/SelectionsHeader";
import Filter from "../../../../layouts/Filter";
import BetShuffle from "../../../../layouts/BetShuffle";
import OnboardingPopup from "../../../../components/OnboardingPopup";
import { AddFavourites } from "../AddFavourites";
import { MyFavourites } from "../MyFavourites";
import { EditFavourites } from "../EditFavourites";
import { Warning } from "../Warning";

export default function PageLayout({
  toggleOnboarding,
  closeOnboarding,
  showOnboarding,
  children,
}) {
  return (
    <>
      {/* If the user hasn't gone through the onboarding process previously and there is no onboardingSeen 
              localStorage item that exists and if toggleOnboarding is true then the onboarding should display */}
      {toggleOnboarding ? (
        <OnboardingPopup close={() => closeOnboarding()} />
      ) : null}
      <Header
        showOnboarding={showOnboarding}
        closeOnboarding={closeOnboarding}
      />
      <SelectionsHeader>{children}</SelectionsHeader>
      <Filter />
      <BetShuffle />
      <AddFavourites />
      <EditFavourites />
      <MyFavourites />
      <Warning />
    </>
  );
}
